<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_702_5012)">
      <path
        d="M0.746094 16.1743C2.44161 20.7439 6.84012 24.0004 11.9997 24.0004C17.1593 24.0004 21.5578 20.7439 23.2533 16.1743L11.9997 15.1309L0.746094 16.1743Z"
        fill="#FFDA44"
      />
      <path
        d="M11.9997 0C6.84012 0 2.44161 3.2565 0.746094 7.82611L11.9997 8.86955L23.2533 7.82606C21.5578 3.2565 17.1593 0 11.9997 0Z"
        fill="black"
      />
      <path
        d="M0.746391 7.82617C0.264047 9.12616 0 10.5322 0 12.0001C0 13.4679 0.264047 14.874 0.746391 16.174H23.2537C23.736 14.874 24 13.4679 24 12.0001C24 10.5322 23.736 9.12616 23.2536 7.82617H0.746391Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_702_5012">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
<script lang="ts">
import { defineComponent } from "vue"
export default defineComponent({})
</script>
